// extracted by mini-css-extract-plugin
export var black = "_2m-6";
export var brand = "_2m-1";
export var ddefault = "_2m-0";
export var error = "_2m-3";
export var gray = "_2m-2";
export var highContrast = "_2m-8";
export var outline = "_2m-7";
export var success = "_2m-5";
export var warning = "_2m-4";